import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { preloadOptions } from '../Options/preloadOptions.ts';

import useDraftsDataHomeDraftsQuery, {
	type useDraftsDataHomeDraftsQuery$data,
	type useDraftsDataHomeDraftsQuery$variables,
} from './__generated__/useDraftsDataHomeDraftsQuery.graphql.ts';
import { getDraftsQueryOptions } from './draftsQueryHelpers.ts';

export const preloadDrafts = ({ isLoggedIn }) => {
	const { variables } = getDraftsQueryOptions({});
	return waitForAllReturnWhenError([
		query<useDraftsDataHomeDraftsQuery$data, useDraftsDataHomeDraftsQuery$variables>({
			query: useDraftsDataHomeDraftsQuery,
			variables,
		}),
		preloadOptions({ isLoggedIn }),
	]);
};
